module.exports = __webpack_public_path__ + "media/mosaics/Mosaics-lg-389adb97.jpg";